<template>
  <div>
    <div class="card">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">{{ $t('acompte.title')}}</h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <b-field :label="$t('acompte.designation')" type="typeNom" class="obligatoire">
          <b-input v-model="acompteCreate.designation"></b-input>
        </b-field>
        <b-field :label="$t('acompte.payeur')"
                 class="obligatoire">
          <b-select v-model="acompteCreate.payeurId" expanded>
            <option v-for="payeur in devisCommande.payeurs"
                    :key="payeur.tiersId"
                    :value="payeur.tiersId">
              {{ payeur.nomCommercial }}
            </option>
          </b-select>
        </b-field>
        <b-field>
          <b-field :label="$t('acompte.modeReglement')"
                   class="obligatoire">
            <b-select v-model="acompteCreate.modeReglementId" expanded>
              <option v-for="mode in modesReglement"
                      :key="mode.id"
                      :value="mode.id">
                {{mode.libelle}}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$t('acompte.dateAcompte')"
                   class="obligatoire mgl-30px">
            <b-datepicker show-week-number
              nearby-selectable-month-days
              icon="calendar-today"
              v-model="date"
              :editable="true">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('acompte.nbJourDelaiReglement')"
                   class="obligatoire mgl-30px">
             <qd-numberinput v-model="acompteCreate.nbJourDelaiReglement" :controls="false">
             </qd-numberinput>
          </b-field>
        </b-field>
        <b-field>
          <div class="columns">
            <div class="column is-6">
          <b-field :label="$t('acompte.tva')"
                   class="obligatoire ">
            <b-select v-model="acompteCreate.tauxTva" expanded>
              <option v-for="taux in tva.liste"
                      :value="taux.tauxTva" :key="taux.tauxTva">
                <div v-if="taux.tauxTva === '0'"> {{ $t('acompte.nothing')}} </div>
                <div v-else> {{ taux.tauxTva }}% </div>
              </option>
            </b-select>
          </b-field>
            </div>
            <div class="column is-6">
          <b-field :label="$t('acompte.montant')"
                   class="obligatoire">
            <input-currency v-model="acompteCreate.montantTtc" isNumber="true"></input-currency>
          </b-field>
            </div>
          </div>
        </b-field>
        <b-field :label="$t('acompte.commentaire')">
          <b-input v-model="acompteCreate.commentaire" type="textarea" rows="4">
          </b-input>
        </b-field>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close">
              {{ $t('acompte.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="createAcompte">
              {{ $t('acompte.create') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatIsoDate';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import translate from '@/services/devisCommandes/validation/champsAcompteTranslator';
import validationCreationAcompteAvoir from '@/services/devisCommandes/validation/validationCreationAcompteAvoir';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import * as devisConf from '@/configuration/devisConf';
import { generationFactureAcompte as generationFactureAcompteDevis } from '@/api/devis/index';
import { generationFactureAcompte as generationFactureAcompteCommande } from '@/api/commande/index';
import inputCurrency from '@/components/general/inputCurrency';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import validationChampsObligatoireFacture from '@/services/devisCommandes/validation/validationChampsObligatoireFacture';

const Parametres = createNamespacedHelpers('parametres');
export default {
  props: {
    devisCommande: Object,
    type: String,
  },
  components: {
    inputCurrency,
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      modeReglement: {
        liste: [],
        selected: '',
      },
      editorOption: {
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline'],
          ],
        },
        placeholder: '',
        theme: 'bubble',
      },
      date: new Date(),
      commande: devisConf.TYPE_COMMANDE,
      devis: devisConf.TYPE_DEVIS,
      tva: {
        liste: [{ tauxTva: '0' }],
      },
      acompteCreate: {
        devisCommandeId: this.devisCommande.id,
        payeurId: this.devisCommande.payeurs[0].tiersId,
        designation: '',
        dateAcompte: new Date(),
        modeReglementId: this.devisCommande.payeurs[0].modeReglementId,
        tauxTva: null,
        montantTtc: 0,
        commentaire: '',
        nbJourDelaiReglement: 0,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async createAcompte() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.acompteCreate.dateAcompte = formatDate(this.date);
        let response;
        switch (this.type) {
          case devisConf.TYPE_DEVIS: {
            response = await generationFactureAcompteDevis(this.acompteCreate);
            break;
          }
          case devisConf.TYPE_COMMANDE: {
            response = await generationFactureAcompteCommande(this.acompteCreate);
            break;
          }
          default: {
            throw new Error('Creation acompte type DCF mauvais');
          }
        }
        messageSucces(this.$t('acompte.creationAcompte'));
        loadingComponent.close();
        this.$parent.close();
        this.$router.push({ name: 'c.bodac.factures', params: { id: response.data.result.id } });
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationCreationAcompteAvoir(this.$i18n, e.response, this.messages);
          validationChampsObligatoireFacture(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.devisCommande.repartitionsTva.forEach((tva) => {
        this.tva.liste.push({ tauxTva: tva.tauxTva });
      });
      if (this.devisCommande.repartitionsTva.length === 1) {
        this.acompteCreate.tauxTva = this.devisCommande.repartitionsTva[0].tauxTva;
      }
      if (this.type === devisConf.TYPE_COMMANDE) {
        this.acompteCreate.designation = this.$t('acompte.commandeDesignation') + this.devisCommande.code;
      } else this.acompteCreate.designation = this.$t('acompte.devisDesignation') + this.devisCommande.code;

      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
